module.exports = __webpack_public_path__ + "media/images/sprites/line-050aad5a92be07e7f11db182af0938b5.svg";